import EA from '../helpers/init';
import Swiper from 'swiper';

export default EA.Methods.productDetailSwiper = ($this) => {
    const swiperEl = $this;

    if (!swiperEl) return;

    const productSwiper = new Swiper(swiperEl, {
        speed: 1050,
        spaceBetween: 32,
        slidesPerView: 'auto',
        // slidesPerView: 1.05,
        // spaceBetween: 16,

        breakpoints: {
            600: {
                slidesPerView: 'auto',
                spaceBetween: 24,
            },
        },

        centerInsufficientSlides: true,
        watchOverflow: true,
        watchSlidesProgress: true,

        
    });

    productSwiper.slides.forEach((slide, index) => {
        slide.addEventListener('focusin', () => {
            productSwiper.slideTo(index);
        });
    });
};